export class TestClassExceptionExpectedExcetpion extends Error {

}